module.exports = __webpack_public_path__ + "static/media/suresh.d4ebec10.png";